<div class="form-group">
  <div class="d-flex justify-content-between">
    <label
      class="form-control-label cursor-pointer"
      [popoverTitle]="tooltipTitle"
      [ngbPopover]="tooltipText"
      triggers="mouseenter:mouseleave"
    >
      <span [data-feather]="'info'"></span>
      {{ label }}
    </label>
    <a
      *ngIf="previewUrl"
      [href]="previewUrl"
      target="_blank"
      class="link-primary"
    >
      Visualizar
    </a>
  </div>

  <div class="custom-file">
    <input
      type="file"
      class="custom-file-input"
      [accept]="acceptTypes"
      (change)="onChange($event)"
    />
    <label class="form-control-label"class="custom-file-label">{{ getFileName }}</label>
  </div>
</div>
